import { GIG_GRID_LRG, GIG_GRID_MED, GIG_GRID_SML, GIG_GRID_XLRG } from '../Grid';

export const MAIN = 'main';
export const BOTTOM = 'bottom';

export const getSliderConfig = (boxLocation) => {
    // slightly different settings depending on whether the
    // gig card carousel is at the bottom (using the full page width)
    // or inside the main content column

    let sliderBaseNum = 2;
    let sliderBreakpoints = [
        {
            breakpoint: GIG_GRID_LRG,
            slidesToScroll: 3,
            slides: 3
        },
        {
            breakpoint: GIG_GRID_MED,
            slidesToScroll: 2,
            slides: 2
        },
        {
            breakpoint: GIG_GRID_SML,
            slidesToScroll: 1,
            slides: 1
        }
    ];

    if (boxLocation === BOTTOM) {

        sliderBaseNum = 5;
        sliderBreakpoints = [
            {
                breakpoint: GIG_GRID_XLRG,
                slidesToScroll: 4,
                slides: 4
            },
            {
                breakpoint: GIG_GRID_LRG,
                slidesToScroll: 3,
                slides: 3
            },
            {
                breakpoint: GIG_GRID_MED,
                slidesToScroll: 2,
                slides: 2
            },
            {
                breakpoint: GIG_GRID_SML,
                slidesToScroll: 1,
                slides: 1
            }
        ];

    }

    return {
        sliderBaseNum,
        sliderBreakpoints
    };
};
